export enum CandidateExperienceLevel {
  Internship = 'internship',
  EntryLevel = 'entry_level',
  MidLevel = 'mid_level',
  SeniorLevel = 'senior_level',
  Director = 'director',
  Executive = 'executive'
}

export function getCandidateExperienceLevelLabel(level: CandidateExperienceLevel): string {
  switch (level) {
    case CandidateExperienceLevel.Internship:
      return 'Internship';
    case CandidateExperienceLevel.EntryLevel:
      return 'Entry Level';
    case CandidateExperienceLevel.MidLevel:
      return 'Mid Level';
    case CandidateExperienceLevel.SeniorLevel:
      return 'Senior Level';
    case CandidateExperienceLevel.Director:
      return 'Director';
    case CandidateExperienceLevel.Executive:
      return 'Executive';
    default:
      return '';
  }
}
